//
//    WARNING
//    This file was auto-generated by swagger-typescript-codegen.
//    Please do not make changes here because they may be overwritten.
//

import request from 'superagent';
import { SuperAgentStatic, SuperAgentRequest, Response } from 'superagent';
import {
  CallbackHandler,
  RequestHeadersHandler,
  ConfigureAgentHandler,
  ConfigureRequestHandler,
  Logger,
  RequestHeaders,
  QueryParameters,
  CommonRequestOptions,
  ResponseWithBody,
  InsightServicesResponseWrapper,
} from './types';

export type EmailEventPayload = {
  actor?: string;
  bcc?: Array<string>;
  body?: string;
  cc?: Array<string>;
  clientId?: string;
  correlationId?: string;
  from?: string;
  replyTo?: string;
  subject?: string;
  to?: Array<string>;
};

export type EventResponseData = {
  correlationId?: string;
};

export type EventResponseDataResponseWrapper = {
  data?: EventResponseData;
};

export type ProblemDetails = {
  detail?: string;
  instance?: string;
  status?: number;
  title?: string;
  type?: string;
} & {
  [key: string]: {} & {
    [key: string]: any;
  };
};

/**
 * Insight2Profit EventService
 * @class EventService
 * @param {(string)} [domainOrOptions] - The project domain.
 */
export class EventService {
  private domain: string = '';
  private errorHandlers: CallbackHandler[] = [];
  private requestHeadersHandler?: RequestHeadersHandler;
  private configureAgentHandler?: ConfigureAgentHandler;
  private configureRequestHandler?: ConfigureRequestHandler;

  constructor(domain?: string, private logger?: Logger) {
    if (domain) {
      this.domain = domain;
    }
  }

  getDomain() {
    return this.domain;
  }

  addErrorHandler(handler: CallbackHandler) {
    this.errorHandlers.push(handler);
  }

  setRequestHeadersHandler(handler: RequestHeadersHandler) {
    this.requestHeadersHandler = handler;
  }

  setConfigureAgentHandler(handler: ConfigureAgentHandler) {
    this.configureAgentHandler = handler;
  }

  setConfigureRequestHandler(handler: ConfigureRequestHandler) {
    this.configureRequestHandler = handler;
  }

  private request(
    method: string,
    url: string,
    body: any,
    headers: RequestHeaders,
    queryParameters: QueryParameters,
    form: any,
    reject: CallbackHandler,
    resolve: CallbackHandler,
    opts: CommonRequestOptions
  ) {
    if (this.logger) {
      this.logger.log(`Call ${method} ${url}`);
    }

    const agent = this.configureAgentHandler ? this.configureAgentHandler(request) : request;

    let req = agent(method, url);
    if (this.configureRequestHandler) {
      req = this.configureRequestHandler(req);
    }

    req = req.query(queryParameters);

    if (body) {
      headers['Content-Type'] = 'application/json';
      req.send(body);
    }

    headers['x-insight-ns'] = 'master';

    if (Object.keys(form).length > 0) {
      req.type('form');
      req.send(form);
    }

    if (this.requestHeadersHandler) {
      headers = this.requestHeadersHandler({
        ...headers,
      });
    }

    req.set(headers);

    if (opts.$retries && opts.$retries > 0) {
      req.retry(opts.$retries);
    }

    if ((opts.$timeout && opts.$timeout > 0) || (opts.$deadline && opts.$deadline > 0)) {
      req.timeout({
        deadline: opts.$deadline,
        response: opts.$timeout,
      });
    }

    req.end((error, response) => {
      // an error will also be emitted for a 4xx and 5xx status code
      // the error object will then have error.status and error.response fields
      // see superagent error handling: https://github.com/visionmedia/superagent/blob/master/docs/index.md#error-handling
      if (error) {
        reject(error);
        this.errorHandlers.forEach((handler) => handler(error));
      } else {
        resolve(response);
      }
    });
  }

  /**
   *
   * @method
   * @name EventService#postEventSimpleemail
   * @description /event/simpleemail
   * @param {} body - Insight2Profit EventService
   */
  postEventSimpleemail(
    parameters: {
      body?: EmailEventPayload;
    } & CommonRequestOptions
  ): Promise<ResponseWithBody<200, EventResponseDataResponseWrapper> | ResponseWithBody<400, ProblemDetails>> {
    const domain = parameters.$domain ? parameters.$domain : this.domain;
    let path = '/event/simpleemail';
    if (parameters.$path) {
      path = typeof parameters.$path === 'function' ? parameters.$path(path) : parameters.$path;
    }

    let body: any;
    let queryParameters: QueryParameters = {};
    let headers: RequestHeaders = {};
    let form: any = {};
    return new Promise((resolve, reject) => {
      headers['accept'] = 'application/json';
      headers['content-type'] = 'application/json-patch+json';

      if (parameters['body'] !== undefined) {
        body = parameters['body'];
      }

      if (parameters.$queryParameters) {
        queryParameters = {
          ...queryParameters,
          ...parameters.$queryParameters,
        };
      }

      form = queryParameters;
      queryParameters = {};

      this.request('POST', domain + path, body, headers, queryParameters, form, reject, resolve, parameters);
    });
  }
}

export default EventService;
